<template>
    <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn" :class="evaluateClasses(classes)">
      <it-chart-editor v-bind="$props"></it-chart-editor>
    </dr-wrapper>
    <it-chart-component v-else-if="isVisible" v-bind="$props"></it-chart-component>
</template>

<script>
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'
import itChartComponent from './it-chart-component.vue'
import itChartEditor from './it-chart-editor.vue'
export default {
  mixins: [mixin, inputMixin],
  components: {
    itChartComponent,
    itChartEditor
  }
}
</script>